// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__ZqjI0","content":"Modal_content__M7QV0","header":"Modal_header__s9JYJ","control":"Modal_control__qJqa1","button-control":"Modal_button-control__Jqy+b"};